import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getAlertVideos } from '../../services/VideoService';
import { AlertVideoResponse } from '../../types/Videos';
import { shouldPollAlertVideos } from '../../../components/VideoContainer/MultipleVideo/alertVideoUtils';

const ALERT_VIDEOS_POLL_MS = 3000;

function useGetVideosByAlertId(id: string, fleetId: string): UseQueryResult<AlertVideoResponse> {
  return useQuery(
    ['alert-videos', id, fleetId],
    async (): Promise<AlertVideoResponse> => getAlertVideos(id, fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchOnWindowFocus: true,
      refetchInterval: (data) => (
        shouldPollAlertVideos(data as unknown as Parameters<typeof shouldPollAlertVideos>[0])
          ? ALERT_VIDEOS_POLL_MS
          : false
      ),
    },
  );
}

export default useGetVideosByAlertId;
